import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Button, Row, Col } from 'react-bootstrap';
import * as Yup from 'yup';
import { FormikSelect } from '../../components';

const DashboardDncFilter = props => {
  const { errors, touched, setFieldValue, employees } = props;

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 7 }, (_, i) => {
    const y = currentYear - 1 + i;
    return { label: y.toString(), value: y };
  });

  return (
    <Form className="dnc-dashboard-filter-form pt-2 px-3 mt-2">
      <Row className="align-items-start">
        <Col xs={12} md={4}>
          <Field name="filterYear">
            {({ field }) => (
              <FormikSelect
                {...field}
                abbr
                label="Año"
                placeholder="Seleccionar año"
                options={years}
                onChange={data => setFieldValue(field.name, data ? data.value : '')}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
                required
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={4}>
          <Field name="filterEmployeeIds">
            {({ field }) => (
              <FormikSelect
                {...field}
                label="Colaborador"
                options={employees}
                placeholder="Seleccionar colaborador"
                onChange={data => setFieldValue(field.name, data ? [data.value] : [])}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={1} className="mt-4">
          <Button
            type="submit"
            className="btn-block btn-primary mb-3"
            style={{ backgroundColor: '#1fb58f', borderColor: '#1fb58f' }}
          >
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  filterYear: Yup.string().required('Requerido')
});

const setInitialValues = () => {
  return {
    filterYear: '',
    filterEmployeeIds: []
  };
};

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(DashboardDncFilter);
